/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Skill level requirement for tournament participation
 * @export
 */
export const TournamentSkillLevel = {
    OPEN: 'OPEN',
    BEGINNER: 'BEGINNER',
    INTERMEDIATE: 'INTERMEDIATE',
    ADVANCED: 'ADVANCED',
    PRO: 'PRO'
} as const;
export type TournamentSkillLevel = typeof TournamentSkillLevel[keyof typeof TournamentSkillLevel];


export function instanceOfTournamentSkillLevel(value: any): boolean {
    for (const key in TournamentSkillLevel) {
        if (Object.prototype.hasOwnProperty.call(TournamentSkillLevel, key)) {
            if (TournamentSkillLevel[key as keyof typeof TournamentSkillLevel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentSkillLevelFromJSON(json: any): TournamentSkillLevel {
    return TournamentSkillLevelFromJSONTyped(json, false);
}

export function TournamentSkillLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentSkillLevel {
    return json as TournamentSkillLevel;
}

export function TournamentSkillLevelToJSON(value?: TournamentSkillLevel | null): any {
    return value as any;
}

export function TournamentSkillLevelToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentSkillLevel {
    return value as TournamentSkillLevel;
}

